import {
    BaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart';
import {
    STDLblPos,
    STGrouping,
    SubChartType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import {
    getFirstThemeLineStyle,
    getThemeColorValueByIndex,
    getThemeStyleTransformOpt,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/theme';
import { CANVAS_PT_SCALE } from '@src/slide/infrastructure/module/independent/unit';
import { MarkerType } from '@src/slide/domain/ui-model/element-modeles/property/chart/legend/legend.interface';
import { DataLabelProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label';
import type { IDataLabel, IChartSeries, DataPoint } from '../../../Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import type { ILegendMarker } from '@src/slide/domain/ui-model/element-modeles/property/chart/legend/legend.interface';
import type {
    IChartShapeProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type { ILineChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type {
    ILineChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/line-chart.interface';
import { IDataItemProperty } from './data-item/data-item.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IThemeModel } from '../../../Interface/theme-model.interface';

export class LineChartProperty<T extends ILineChart = ILineChart>
    extends BaseSubChartProperty<T> implements ILineChartProperty {
    public get grouping(): STGrouping {
        return this.uiData.grouping || STGrouping.PBDEFAULT;
    }

    public get is3D() {
        return this.uiData.originType === SubChartType.Line3DChart;
    }

    public getLegendMarker(props: IChartShapeProps): ILegendMarker {
        const { border, fillBackground } = props.style;
        let borderProps = {
            ...border,
        };

        // 3D折线图用填充代替border颜色
        if (this.is3D) {
            borderProps = {
                ...borderProps,
                ...this.createBorderFillWithFillBackground(fillBackground),
            };
        }

        return {
            symbol: MarkerType.Line,
            props: {
                style: {
                    border: borderProps,
                },
            },
        };
    }

    public getDataLabelProperty(dataLabel: IDataLabel, dataItem: IDataItemProperty) {
        return new LineDataLabelProperty(dataLabel, this.context).init(dataItem);
    }

    public getGeometryColorPath = (target?: IChartSeries) => 'props.style.border.tdColor';

    public getDefaultThemeStyle = (target: IChartSeries | DataPoint, index: number, colorPaletteId?: string, total?: number): IChartShapeProps['style'] => {
        const { style } = this.context.getChartModel();
        const { borderScale, accentStartIndex } = getThemeStyleTransformOpt(style);
        const color = this.getThemeColor(index + accentStartIndex, colorPaletteId, total);
        const themeLineStyle = getFirstThemeLineStyle(this.getThemeColorManager()?.currentThemeModel as IThemeModel);
        const noFill = target.props?.style.border?.noFill;
        return {
            border: {
                ...themeLineStyle,
                width: (themeLineStyle?.width || 0) * borderScale || 1.5 * CANVAS_PT_SCALE,
                ...(noFill ? {
                    noFill,
                } : {
                    color,
                    tdColor: color,
                }),
            },
        };
    };
}

export class LineDataLabelProperty extends DataLabelProperty {
    public get labelPosition(): STDLblPos {
        return this.uiData.labelPosition || STDLblPos.r;
    }
}
